<mat-tab-group class="w100">
  <mat-tab label="{{'CERTIFICARV3.TITULO_TAB_PREG'|translate}}">
    <preguntas (guardandoTemplate)="guardandoTemplate = $event" (idiomasGuardados)="enviaIdiomasGuardados($event)" (seccionesGuardadas)="enviaSeccionesGuardadas($event)" [actualizaCuestionarioTrad]="actualizaJsonTrad.asObservable()" [statusPaso]="statusPaso.asObservable()"></preguntas>
  </mat-tab>
  <mat-tab label="{{'CERTIFICARV3.TITULO_TAB_TRAD'|translate}}" *ngIf="traduccionesTab">
    <traducciones (actualizaCuestionario)="actualizaCuestionarioTrad($event)" (traduccionesCompletas)="traduccionesCompletas = $event" (traduccionesTab)="traduccionesTab = $event" [idiomasGuardados]="idiomasGuardados.asObservable()" [seccionesGuardadas]="seccionesGuardadas.asObservable()" [statusPaso]="statusPaso.asObservable()"></traducciones>
  </mat-tab>
  <mat-tab label="{{'CERTIFICARV3.TITULO_TAB_PREV'|translate}}">
    <previsualizacion [idiomasGuardados]="idiomasGuardados.asObservable()" [seccionesGuardadas]="seccionesGuardadas.asObservable()"></previsualizacion>
  </mat-tab>
</mat-tab-group>
<div class="guardandoTemplate" *ngIf="guardandoTemplate" fxLayout="row" fxLayoutAlign="start center">
  <em class="mr-20">{{'CERTIFICARV3.GUAR_CAMB'|translate}}</em>
  <mat-spinner diameter="25"></mat-spinner>
</div>
<ng-container *ngIf="changeInfoFin">
  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20">
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>


    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearPasosSecciones()" mat-fab aria-label=""
    matTooltip="{{'CERTIFICAR.COLABORADORES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
    >
    <mat-icon>lock_open</mat-icon>
  </button>

  <button *ngIf="!pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearPasosSecciones()" mat-raised-button class="reopen mr-20">
    {{'CERTIFICAR.COLABORADORES.STATUS.UNLOCK' | translate}}
    <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
  </button>
</div>
</ng-container>
